import { makePieActionObjs } from 'shared/imports/pieActionGenerators'
import { prependAppName } from 'shared/imports/sharedHelperFunctions'

const appName = '@@lists/'

const getListItemsObj = makePieActionObjs('get', 'list_items')
const getMoreListItemsObj = makePieActionObjs('get', 'more_list_items')
const downloadListObj = makePieActionObjs('get', 'list_as_download')

export const getListItems = prependAppName(appName, getListItemsObj.pieDict)
export const getMoreListItems = prependAppName(appName, getMoreListItemsObj.pieDict)
export const downloadList = prependAppName(appName, downloadListObj.pieDict)

const setListState = 'SET_LIST_STATE'
const initializeList = 'INITIALIZE_LIST'
const resetLoadingState = 'RESET_LOADING_STATE'
const setListsForRefresh = 'SET_LISTS_FOR_REFRESH'

const actionTypes = prependAppName(
    appName,
    {
        setListState,
        initializeList,
        resetLoadingState,
        setListsForRefresh,
        ...getListItemsObj.actionTypes,
        ...getMoreListItemsObj.actionTypes,
        ...downloadListObj.actionTypes,
    }
)

export default actionTypes
